import { withLocalState } from 'pyradux';

import CryptoTransactionsContainer from './CryptoTransactions.container';
import reducer from './CryptoTransactions.reducer';
import CryptoTransactionsSagas from './CryptoTransactions.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'cryptoTransactions',
  sagas: [CryptoTransactionsSagas],
};

export default withLocalState(withLocalStateOptions, CryptoTransactionsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/CryptoTransactions/index.js